<template>
    <div >
    <!-- ====== Blog Start ====== -->
    <section class="ch-gw-blog-grids">
      <div class="container m_container ch-gw-animation">
        <div class="row">
          <div class="col-lg-4 col-md-6 product_index" @click="clickme(item)" v-for="(item,index) in detaileds">
            <a href="javascript:void(0)" style="width: 100%;">
            <div class="ch-gw-blog product_index_blog">
              <div class="ch-gw-blog-image">
                
                  <div class="ch-gw-blog-image-pd product_index_image">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.productImag[0]"
                      fit="fill">
                      </el-image>
                  </div>
              </div>
              <div class="ch-gw-blog-content">
                <span class="ch-gw-blog-date" style="max-width: 80%;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow:ellipsis; ">{{ item.productClassification }}</span>
                <h3 class="ch-gw-blog-title" style="text-overflow: ellipsis;display: -webkit-box;word-break:break-all;text-overflow: -o-ellipsis-lastline;line-clamp: 1;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 1;">
                   {{ item.productName }}
                 
                </h3>
                <p class="ch-gw-blog-desc" style="text-overflow: ellipsis;display: -webkit-box;word-break:break-all;text-overflow: -o-ellipsis-lastline;line-clamp: 3;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 3;">
                    {{ item.productViceName }}
                </p>
              </div>
            </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      pname:'',
      urls:{
        a6: require('@/assets/ch/cpzx-wz.png'),
        a7: require('@/assets/ch/cpzx.png'),
      },
    }
  }, 
  props: ['detaileds'],
  mounted() {

  },
    methods: {
        clickme(item){
            // 通过自定义事件addNum把值传给父组件
            this.$emit('getDataDetailed',item)
        },
        
    }
}
</script>
<style>
  .ch-gw-blog-grids{
    padding-top: 60px;
    padding-bottom: 20px;
  }
  .ch-gw-blog-image-pd:hover{
    transform: scale(1.1);
  }
  .ch-gw-blog-image-pd{
    transition: transform 0.5s ease;
  }
</style>


// WEBPACK FOOTER //
// src/components/product/index.vue